import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PortalLayout from "@/layouts/PortalLayout";
import PortalLanding from "@/pages/portal/PortalLanding";
import PortalAbout from "@/pages/portal/PortalAbout";
import PortalAssessment from "@/pages/portal/PortalAssessment";
import PortalDashboard from "@/pages/portal/PortalDashboard";
import PortalAuth from "@/pages/portal/PortalAuth";
import Auth from "./pages/Auth";
import SchoolAdmin from "./pages/SchoolAdmin";
import SharedResults from "./pages/SharedResults";
import NotFound from "./pages/NotFound";
import Ranger from "./components/Ranger";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            {/* ── High School Portal ─────────────────────────────────── */}
            <Route path="/hs" element={<PortalLayout portal="hs" />}>
              <Route index element={<PortalLanding />} />
              <Route path="about" element={<PortalAbout />} />
              <Route path="auth" element={<PortalAuth />} />
              <Route path="assessment" element={<ProtectedRoute><PortalAssessment /></ProtectedRoute>} />
              <Route path="dashboard" element={<ProtectedRoute><PortalDashboard /></ProtectedRoute>} />
              <Route path="admin" element={<ProtectedRoute><SchoolAdmin /></ProtectedRoute>} />
            </Route>

            {/* ── College Portal ─────────────────────────────────────── */}
            <Route path="/college" element={<PortalLayout portal="college" />}>
              <Route index element={<PortalLanding />} />
              <Route path="about" element={<PortalAbout />} />
              <Route path="auth" element={<PortalAuth />} />
              <Route path="assessment" element={<ProtectedRoute><PortalAssessment /></ProtectedRoute>} />
              <Route path="dashboard" element={<ProtectedRoute><PortalDashboard /></ProtectedRoute>} />
            </Route>

            {/* ── Professional Portal ────────────────────────────────── */}
            <Route path="/pro" element={<PortalLayout portal="pro" />}>
              <Route index element={<PortalLanding />} />
              <Route path="about" element={<PortalAbout />} />
              <Route path="auth" element={<PortalAuth />} />
              <Route path="assessment" element={<ProtectedRoute><PortalAssessment /></ProtectedRoute>} />
              <Route path="dashboard" element={<ProtectedRoute><PortalDashboard /></ProtectedRoute>} />
            </Route>

            {/* ── Global routes ──────────────────────────────────────── */}
            <Route path="/auth" element={<Auth />} />
            <Route path="/shared/:shareId" element={<SharedResults />} />

            {/* ── Backward-compatible redirects (old URLs still work) ─ */}
            <Route path="/" element={<Navigate to="/hs" replace />} />
            <Route path="/high-school" element={<Navigate to="/hs/assessment" replace />} />
            <Route path="/dashboard" element={<Navigate to="/hs/dashboard" replace />} />
            <Route path="/admin" element={<Navigate to="/hs/admin" replace />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Ranger />
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
